import { render, staticRenderFns } from "./ModalDenyOnboarding.vue?vue&type=template&id=7dcaedee&scoped=true&"
import script from "./ModalDenyOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ModalDenyOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDenyOnboarding.vue?vue&type=style&index=0&id=7dcaedee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcaedee",
  null
  
)

export default component.exports